import commercialImg from "../images/afro-solar/smart-city/commertial-solutions.webp";
import residentialImg from "../images/afro-solar/smart-city/residential-solutions.webp";
import utilityScaleImg from "../images/afro-solar/smart-city/utility-scale-solution.webp";

const smartCityOptions = [
  {
    title: "Residential Solutions",
    description:
      "Save on your electricity bills, reduce your carbon footprint and increase the value of your home.",
    img: residentialImg,
  },
  {
    title: "Utility-Scale Solutions",
    description:
      "Own a solar power plant, procure solar contracts or offer solar directly to your customers with a solid business partner. ",
    img: utilityScaleImg,
  },
  {
    title: "Commercial Solutions",
    description:
      "Make the smart investment and choose solar for your business. Lock in energy rates, demonstrate corporate social responsibility and achieve energy independence.",
    img: commercialImg,
  },
];

const SmartCity = () => {
  return (
    <section id="smart-city">
      <section className="pt-13">
        <h2 className="fs-56 lh-64 gilroy-bold text-center text-uppercase">
          Smart<span className="text-orange-ryb"> City</span>
        </h2>
        <p className="text-uppercase fs-16 text-center mb-5">
          MADE-TO-MEASURE SOLAR-INTEGRATED SOLUTIONS​
        </p>
      </section>
      <section className="container-fluid mt-5">
        <div className="me-35 ms-35">
          <div className="row">
            {smartCityOptions.map((option) => (
              <div
                key={option.title}
                className="col-12 col-sm-6 col-md-4 pb-5 pb-md-0"
              >
                <div className="shadow-sm p-3 h-100 card-design-3">
                  <img
                    src={option.img}
                    loading="lazy"
                    alt={option.title}
                    className="d-block img-fluid"
                  />
                  <h3 className="fs-18 gilroy-bold mt-4">{option.title}</h3>
                  <p className="fs-16">{option.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </section>
  );
};

export default SmartCity;
